<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
                <!-- <el-button type="primary" size="small" icon="iconfont icon-jia shuaxin" @click="dialogFormVisible = true">新增</el-button> -->
            </el-col>

            <!-- search start  -->
            <el-col :span="24" class="search-content">
                <div class="search-item" style="width: 150px;">
                    <el-select v-model="data.is_prize" placeholder="请选择是否中奖" size="small" clearable>
                        <el-option
                            v-for="item in [
                              {id: 1, name: '中奖'},
                              {id: 0, name: '未中奖'},
                            ]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item" style="width: 150px;">
                    <el-select v-model="data.is_open" placeholder="请选择是否开奖" size="small" clearable>
                        <el-option
                            v-for="item in [
                              {id: 1, name: '未开奖'},
                              {id: 2, name: '已开奖'},
                            ]"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="search-item" style="width: 150px;">
                    <el-input v-model="data.nickname" size="small" placeholder="请输入会员昵称" clearable></el-input>
                </div>
                <div class="search-item" style="width: 150px;">
                    <el-input v-model="data.open_periods" size="small" placeholder="请输入开奖期数" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col>
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="user_id" label="会员昵称" width="180">
                      <template slot-scope="scope">
                        <span>{{scope.row.nickname}} (ID: {{scope.row.user_id}})</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="number" label="抽奖号码" width="150"></el-table-column>
                    <el-table-column prop="is_prize" label="是否中奖" width="150">
                      <template slot-scope="scope" v-if="scope.row.is_open == 2">
                        <span v-if="scope.row.is_prize == 1" style="color: #F56C6C;">
                          <span v-if="scope.row.prize_grade == 1">一等奖</span>
                          <span v-if="scope.row.prize_grade == 2">二等奖</span>
                          <span v-if="scope.row.prize_grade == 3">三等奖</span>
                          <span v-if="scope.row.prize_grade == 4">四等奖</span>
                        </span>
                        <span v-else style="color: #909399;">未中奖</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="is_open" label="是否开奖" width="150">
                      <template slot-scope="scope">
                        <span v-if="scope.row.is_open == 2" style="color: #F56C6C;">已开奖</span>
                        <span v-else style="color: #909399;">待开奖</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="is_source" label="来源" width="150">
                      <template slot-scope="scope">
                        <span v-if="scope.row.is_source == 1" >后台赠送</span>
                        <span v-else >消费赠送</span>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column prop="open_at" label="开奖时间" width="180"></el-table-column> -->
                    <el-table-column prop="open_periods" label="开奖期数" width="150"></el-table-column>
                    <el-table-column prop="content" label="奖品" width="150"></el-table-column>
                    <el-table-column prop="status" label="是否核销" width="150">
                      <template slot-scope="scope" v-if="scope.row.is_prize == 1">
                        <span v-if="scope.row.status == 1" style="color: #F56C6C;">待核销</span>
                        <span v-else style="color: #909399;">已核销</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="created_at" label="获得时间" width="180"></el-table-column>
                    <el-table-column label="操作" min-width="180">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.is_prize == 1 && scope.row.status == 1" @click="setStatus(scope.row.id)" icon="iconfont iconhexiaoqueren shuaxin" size="mini" type="warning" plain :disabled="!power.user_prize_set_status">核销</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {UserPrizeIndex, UserPrizeSetStatus} from "@/utils/request.js"
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    is_prize: '',
                    is_open: '',
                    nickname: '',
                    open_periods: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                loadingAdd: false,
                dialogTitle: "新增XXX",
                formLabelWidth: "120px",
                form: {
                    id: 0,
                    user_id: "",
                },
                multipleSelection: [],
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(["power"]),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                UserPrizeIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            handleSelectionChange(val) {
                this.multipleSelection = []
                if (val.length > 0) {
                    val.filter((item) => {
                        this.multipleSelection.push(item.id)
                    })
                }
            },
            setStatus(id) {
                this.$confirm("确定要核销当前中奖记录吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    UserPrizeSetStatus({id: id}).then((res) => {
                        if (res.code == 200) {
                            this.data.page--
                            this.getList()
                            this.$message.success(res.msg);
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    // 取消操作
                });
            },
        }
    }
</script>

<style>
</style>
